(() => {
  function init(root) {
    if (root.dataset.mixReady) return;
    const configNode = root.querySelector('[data-mix-config]');
    if (!configNode) return;
    let config;
    try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
    const names = ['Matcha', 'Chai', 'Ube'];
    const flavours = ['matcha', 'chai', 'ube'];
    const variants = config.variants.map(v => ({ ...v, counts: names.map(name => Number((v.title.match(new RegExp('(\\d+) × ' + name)) || [0,0])[1])) }));
    let counts = (variants.find(v => String(v.id) === String(config.initial)) || variants.find(v => v.counts.join() === '1,1,1'))?.counts.slice() || [1,1,1];
    const forms = Array.from(root.querySelectorAll('form')).filter(f => f.querySelector('[data-mix-variant]'));
    const buttons = Array.from(root.querySelectorAll('button[type="submit"]')).filter(b => forms.includes(b.form));
    const pickers = Array.from(root.querySelectorAll('[data-mix-picker]'));
    if (!forms.length || !variants.length) return;
    let selected;
    let valid = false;
    const replaceCount = (s,n) => s.replace('__COUNT__', String(n));
    function render() {
      const total = counts.reduce((a,b) => a+b,0);
      selected = variants.find(v => v.counts.join() === counts.join());
      valid = Boolean(config.enabled && total === 3 && selected?.available);
      const summary = counts.map((n,i) => n ? n + ' × ' + names[i] : '').filter(Boolean).join(' + ');
      root.querySelectorAll('[data-mix-progress]').forEach(el => el.textContent = replaceCount(config.progress,total));
      root.querySelectorAll('[data-mix-status]').forEach(el => el.textContent = total !== 3 ? replaceCount(config.remaining,3-total) : valid ? config.ready : config.unavailable);
      root.querySelectorAll('[data-mix-summary]').forEach(el => el.textContent = summary);
      root.querySelectorAll('[data-mix-count]').forEach(el => el.textContent = String(counts[flavours.indexOf(el.dataset.mixCount)]));
      root.querySelectorAll('[data-mix-step]').forEach(el => { const i=flavours.indexOf(el.dataset.flavour); el.disabled=Number(el.dataset.mixStep)<0 ? counts[i]===0 : total>=3; });
      root.querySelectorAll('[data-mix-preset]').forEach(el => el.setAttribute('aria-pressed',String(el.dataset.mixPreset===counts.join())));
      forms.forEach(form => { form.querySelector('[data-mix-variant]').value = valid ? String(selected.id) : ''; });
      buttons.forEach(button => { if (button.getAttribute('aria-busy')==='true') return; button.disabled=!valid; button.textContent = !valid ? config.choose : button.closest('.lt-sticky') ? config.sticky : config.buy.replace('__PRICE__',selected.money); });
      if (selected) root.querySelectorAll('[data-mix-price]').forEach(el => el.textContent = selected.money);
    }
    root.addEventListener('click', event => {
      const preset=event.target.closest('[data-mix-preset]');
      const step=event.target.closest('[data-mix-step]');
      if (!preset && !step) return;
      if (buttons.some(b => b.getAttribute('aria-busy')==='true')) return;
      if (preset) counts=preset.dataset.mixPreset.split(',').map(Number);
      if (step) { const i=flavours.indexOf(step.dataset.flavour),delta=Number(step.dataset.mixStep); if (i<0 || counts[i]+delta<0 || counts.reduce((a,b)=>a+b,0)+delta>3) return; counts[i]+=delta; }
      render();
    });
    root.addEventListener('submit', event => { if (!forms.includes(event.target)) return; render(); if (!valid) { event.preventDefault(); event.stopPropagation(); pickers[0]?.querySelector('button:not(:disabled)')?.focus(); } }, true);
    root.dataset.mixReady='true';
    root.classList.add('mix-enhanced');
    pickers.forEach(el => el.hidden=false);
    render();
  }
  document.querySelectorAll('[data-mix-root]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-mix-root]').forEach(init));
})();
